import "../../css/Home.css";
import { Link } from 'react-router-dom';
import "./../../css/Forms.css"
import { isFaculty } from "../../helpers/permissions";

export default function Home({ user }) {

    return (
        <div className="home-container">
            <div className="home-text">
                <h1>Welcome to the Student Advising Application for Computer Science (SAACS)</h1>
                <p>This tool is designed to help streamline the advising process for both students and advisors.</p>
                {user ?
                (isFaculty(user) && user.permissions === 0) ?
                    <Link className="btn btn-primary" style={{width:"100px"}} to={"/sars"}>View SARs</Link>
                : (
                    <>
                        {(user.permissions === 0 || user.pid === "bbradner") && <>
                            <Link className="btn btn-primary" style={{width:"100px"}} to={"/sar/new"}>New SAR</Link>
                            <Link className="btn btn-primary" style={{width:"100px"}} to={"/sar/review/"}>View SAR</Link>
                        </>}
                        <Link className="btn btn-primary" style={{width:"100px"}} to={"/ug/forceadd"}>Undergraduate Force Add</Link>
                        <Link className="btn btn-primary" style={{width:"100px"}} to={"/grad/forceadd"}>Graduate Force Add</Link>
                        {((user.permissions & 1) == 1) &&
                            <Link className="btn btn-primary" style={{width:"100px"}} to={"/submissions"}>P91</Link>
                        }
                        {(user.permissions & 8) > 0 && <>
                            <Link className="btn btn-primary" style={{width:"100px"}} to={"/sars"}>View SARs</Link>
                            <Link className="btn btn-primary" style={{width:"100px"}} to={"/sars/admin"}>SAR Admin</Link>
                        </>}
                    </>
                ) : (<p>Click <a href="/api/login">here</a> to sign in.</p>)}
            </div>
        </div>

    );
}
